import React from 'react';
import axios from 'axios';
import legolasApi from '../../api/legolas';
import generateToken from '../../utils/generateToken';

function AdminLogin() {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const data = {
        "user_id": storedUser.id
    };
    const signedToken = generateToken(data);
    React.useEffect(() => {
        axios.get(`${legolasApi.url}/admin/user/adminuser`,{
                headers: {
                    'Authorization': `Bearer ${signedToken}`,
                    'Content-Type': 'application/json'
                }
            }).then((res) => {
                console.log("userdata",storedUser)
                console.log('search res: ', res.data.data.admin_role_id);
                const adminRoleId = res.data.data.admin_role_id;  
                const channelId = res.data.data.channel;  
                if (adminRoleId !== storedUser.admin_role_id) {
                    storedUser.admin_role_id = adminRoleId;
                    localStorage.setItem("user", JSON.stringify(storedUser));
                }
                if (channelId && JSON.stringify(channelId) !== JSON.stringify(storedUser.channel)) {
                    storedUser.channel = channelId;
                    localStorage.setItem("user", JSON.stringify(storedUser));
                }
            }).catch((error) => console.log('Error', error));
    }, []);
}

export default AdminLogin;